import { temporarilyNotSupport } from '../../utils'

// 屏幕
export const setVisualEffectOnCapture = temporarilyNotSupport('setVisualEffectOnCapture')
export const setScreenBrightness = temporarilyNotSupport('setScreenBrightness')
export const setKeepScreenOn = temporarilyNotSupport('setKeepScreenOn')
export const onUserCaptureScreen = temporarilyNotSupport('onUserCaptureScreen')
export const offUserCaptureScreen = temporarilyNotSupport('offUserCaptureScreen')
export const getScreenBrightness = temporarilyNotSupport('getScreenBrightness')
